import React from 'react';
import { useTranslation } from 'react-i18next';

function Info(props) {

    const {t} = useTranslation();
    return (
        <div className="text-footer-text text-sm order-2 tablet:order-1 align-center justify-center">
            <p>{t('general.footer.copyright')}</p>
        </div>
    );
}

export default Info;
